module.exports = __webpack_public_path__ + "static/media/pokeball.5475782f.png";